import { IIndexable } from "@constants/common";

export const RESOURCE_API_CONFIG = {
  URL: "https://kelp-dao.ghost.io/ghost/api/content/posts",
  KEY: "74697a5b18799be75ef3bcdc67",
};

export const blogTagMapping: { [x: string]: string } = {
  // "terra-2-0": "terra-2-0",
  // "staking-basics": "staking-basics",
  // sd: "sd",
  // polygon: "polygon",
  // bnbchain: "bnbchain",
  // ethereum: "ethereum",
  // hedera: "hedera",
  // fantom: "fantom",
  // near: "near",
  // crypto: "crypto",
  // engineering: "engineering",
};

export const tagLabelMap: IIndexable = {
  // "terra-2-0": "Terra 2.0",
  // "staking-basics": "Staking Basics",
  // sd: "SD",
  // polygon: "Polygon",
  // bnbchain: "BNB",
  // ethereum: "Ethereum",
  // hedera: "Hedera",
  // fantom: "Fantom",
  // near: "Near",
  // crypto: "Crypto",
  // engineering: "engineering",
};

export const socialImageMapping: IIndexable = {
  twitter: "/assets/blog/twitter.svg",
  telegram: "/assets/blog/telegram.svg",
  // whatsapp: "/assets/blog/whatsapp.svg",
  // facebook: "/assets/blog/facebook.svg",
  linkedin: "/assets/blog/linkedin.svg",
  // discord: "/assets/blog/discord.svg",
};
